var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin-landing-page"},[_c('containers'),_c('vehicle-of-interest-modal',{attrs:{"vehicle-id":_vm.vehicleOfInterestId}}),_c('mobile-footer',{attrs:{"vehicle-id":_vm.vehicleOfInterestId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }